<template>
  <div class="footer" :class="className">
    <div class="wrap">
      <div class="footer-main">
        <!-- 关于我们 -->
        <div class="footer-block">
          <h4>关于我们</h4>
          <p>济南鲁凝教育咨询服务有限公司</p>
          <p>地址：山东省济南市历下区仁恒世纪花园2号楼101</p>
          <p class="footer-browser">建议使用 Chrome、Edge、Firefox 等主流浏览器</p>
        </div>

        <!-- 客服电话 -->
        <div class="footer-block footer-block-center">
          <h4>客服电话</h4>
          <p class="footer-phone">195 3811 6105（同微信）</p>
        </div>

        <!-- 友情链接 -->
        <div class="footer-block">
          <h4>友情链接</h4>
          <a href="http://zjt.shandong.gov.cn/" target="_blank" rel="noopener">山东省住房和城乡建设厅</a>
          <a href="http://www.shandong.gov.cn/" target="_blank" rel="noopener">山东省人民政府</a>
        </div>
      </div>

      <!-- 备案信息 -->
      <div class="footer-bottom">
        <p class="footer-copy">&copy; 2025 山东省二级建造师继续教育平台. All rights reserved.</p>
        <p class="footer-icp"><a href="https://beian.miit.gov.cn" target="_blank">鲁ICP备2025188245号-1</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  data() {
    return {
      className: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.isAbsolute();
      }, 500);
    });
  },
  methods: {
    isAbsolute() {
      const parentHeight = document.querySelector("#app").offsetHeight;
      const viewportHeight = window.innerHeight;
      if (viewportHeight > parentHeight) {
        this.className = "absolute";
      } else {
        this.className = "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  background: linear-gradient(180deg, #1e293b, #0f172a);
  padding: 20px 20px 0;
  margin-top: 40px;

  .wrap {
    max-width: 1100px;
    margin: 0 auto;
  }

  // 友情链接 / 关于我们 并列
  .footer-main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 60px;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .footer-block {
    h4 {
      color: #e2e8f0;
      font-size: 14px;
      font-weight: 600;
      margin: 0 0 10px;
      padding-bottom: 6px;
      border-bottom: 2px solid #4a86c8;
      display: inline-block;
    }

    p,
    a {
      display: block;
      margin: 0;
      font-size: 13px;
      color: #a0aec0;
      line-height: 1.9;
      text-decoration: none;
    }

    a {
      transition: color 0.2s;

      &:hover { color: #4a86c8; }
    }

    .footer-browser {
      font-size: 12px;
      color: #718096;
    }
  }

  // 中间的客服电话
  .footer-block-center {
    text-align: left;

    .footer-phone {
      font-size: 15px;
      color: #a0aec0;
      letter-spacing: 0.5px;
    }
  }

  // 备案信息（底部居中）
  .footer-bottom {
    padding: 12px 0 14px;
    text-align: center;

    p {
      margin: 0;
      font-size: 12px;
      color: #718096;
      line-height: 1.7;
    }

    .footer-icp a {
      color: #718096;
      text-decoration: none;

      &:hover { color: #4a86c8; }
    }
  }
}

.absolute {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}

@media (max-width: 768px) {
  .footer .footer-main {
    flex-direction: column;
    gap: 18px;
  }
}
</style>
